import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesOverview from './components/ServicesOverview';
import CTASection from './components/CTASection';

const HomePage = () => {
  useEffect(() => {
    document.title = 'Riverdale Hair Studio | Premier Hair & Beauty Salon in Otley, West Yorkshire';
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesOverview />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;